// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2osMf","title":"InfoRow_title__23NI6"};